/*
    © 2023 EcomGraduates.com
    https://www.ecomgraduates.com
*/

// Refresh cart contents (offcanvas cart, cart page, count badges, etc)
window.refreshCartContents = async (response) => {
    console.log(response)

    const offcanvasCart = document.querySelector('#offcanvas-cart')
    const cartPage = document.querySelector('#cart')

    offcanvasCart?.classList.add('loading')
    cartPage?.classList.add('loading')

    // CRITICAL FIX: Fetch cart data FIRST (before DOM replacement)
    let cartData = null
    try {
        const cartResponse = await fetch('/cart.js')
        cartData = await cartResponse.json()
        window.cartData = cartData // Store globally
    } catch (error) {
        console.error('Failed to fetch cart data:', error)
    }

    const newResponse = await fetch(window.location.href)
    const text = await newResponse.text()
    const newDocument = new DOMParser().parseFromString(text, 'text/html')

    offcanvasCart?.querySelector('.offcanvas-body')
        .replaceWith(newDocument.querySelector('#offcanvas-cart .offcanvas-body'))
    offcanvasCart?.querySelector('.offcanvas-footer')
        .replaceWith(newDocument.querySelector('#offcanvas-cart .offcanvas-footer'))
    cartPage?.replaceWith(newDocument.querySelector('#cart'))

    document.querySelectorAll('.cart-count-badge').forEach((badge) => {
        badge.textContent = newDocument.querySelector('.cart-count-badge').textContent
        badge.removeAttribute('hidden')
    })

    // CRITICAL FIX: Force immediate shipping update after DOM replacement
    if (window.CartEnhancementManager && cartData) {
        // Small delay to ensure DOM is stable
        setTimeout(() => {
            window.CartEnhancementManager.updateShippingThreshold(cartData)
        }, 50)
    }

    // Dispatch event with cart data included
    window.dispatchEvent(new CustomEvent('updated.ecomify.cart', {
        detail: { cart: cartData }
    }))

    offcanvasCart?.classList.remove('loading')
    cartPage?.classList.remove('loading')

    if (response && response.ok) {
        if (response.url && response.url.includes('add.js')) {
            // Safely try to show add alert
            const addAlert = offcanvasCart?.querySelector('#offcanvas-cart-alert-add');
            if (addAlert) {
                addAlert.removeAttribute('hidden');

                const data = await response.json();

                if (data.items?.length > 1) {
                    const elemAlertItemsAdded = offcanvasCart?.querySelector('#offcanvas-cart-alert-add [data-alert-items-added]');
                    if (elemAlertItemsAdded) {
                        elemAlertItemsAdded.textContent = elemAlertItemsAdded.textContent.replace('[count]', data.items.length);
                        elemAlertItemsAdded.removeAttribute('hidden');
                    }
                } else {
                    const itemAddedAlert = offcanvasCart?.querySelector('#offcanvas-cart-alert-add [data-alert-item-added]');
                    if (itemAddedAlert) {
                        itemAddedAlert.removeAttribute('hidden');
                    }
                }
            }
        } else {
            // Safely try to show updated alert
            const updatedAlert = offcanvasCart?.querySelector('#offcanvas-cart-alert-updated');
            if (updatedAlert) {
                updatedAlert.removeAttribute('hidden');
            }
        }
    } else if (response) {
        // Handle error case safely
        try {
            const data = await response.json();
            const alert = document.querySelector('#offcanvas-cart-alert-error');
            if (alert) {
                const span = alert.querySelector('span');
                if (span) {
                    span.textContent = `${data.message || 'Error'} - ${data.description || 'Failed to add to cart'}`;
                }
                alert.removeAttribute('hidden');
            }
        } catch (error) {
            console.error('Error handling cart error response:', error);
        }
    }

    if (offcanvasCart?.querySelector('#offcanvas-cart-empty')) {
        setTimeout(() => {
            bootstrap.Offcanvas.getOrCreateInstance(offcanvasCart).hide()
        }, 1000)
    }

    if (offcanvasCart?.querySelector('#cart-shipping-rates')) {
        // eslint-disable-next-line no-new
        new Shopify.CountryProvinceSelector('shipping-rates-modal-country', 'shipping-rates-modal-province', {
            hideElement: 'shipping-rates-modal-province-wrapper'
        })
    }
}

// Quantity Inputs
window.onChangeCartQty = async (input) => {
    const response = await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
            id: input.dataset.lineItemKey,
            quantity: input.value
        })
    })
    window.refreshCartContents(response)
}

// Remove Buttons
window.onRemoveCartItem = async (btn) => {
    const response = await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
            id: btn.dataset.lineItemKey,
            quantity: 0
        })
    })
    window.refreshCartContents(response)
}

// Cart note - Save note via ajax
window.onSaveCartNote = async (btn) => {
    btn.innerHTML = `
        <div class="spinner-border spinner-border-sm" role="status" style="width: 1rem; height: 1rem">
            <span class="visually-hidden">Loading...</span>
        </div>
    `

    const note = btn.closest('#cart-note').querySelector('[name="note"]').value

    await fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ note })
    })

    btn.innerHTML = `✓ <span class="visually-hidden">${btn.dataset.textNoteSaved}</span>`

    setTimeout(() => {
        btn.innerHTML = btn.dataset.textBtnSave
    }, 4000)
}

// Checkout button - indicate loading on click
window.onClickCheckoutBtn = (btn) => {
    btn.style.height = btn.clientHeight + 'px'
    btn.innerHTML = `
        <div class="spinner-border spinner-border-sm" role="status" style="width: 1.2rem; height: 1.2rem">
            <span class="visually-hidden">Loading...</span>
        </div>
    `
}

// Cart Goal - Comprehensive JavaScript-driven system
const updateCartGoal = async () => {
    const cartGoal = document.querySelector('#cart-goal')
    if (!cartGoal) return

    try {
        // Fetch fresh cart data
        const cartResponse = await fetch('/cart.js')
        const cart = await cartResponse.json()

        // Get thresholds from data attributes
        const shippingThreshold = parseFloat(cartGoal.dataset.shippingThreshold) || 75
        const goal2Threshold = parseInt(cartGoal.dataset.goal2Threshold) || 4
        const goal3Threshold = parseInt(cartGoal.dataset.goal3Threshold) || 6

        // Upsell variant IDs to exclude from cart goal counting
        const UPSELL_VARIANT_IDS = [
            34054986596483,  // Warranty/Protection
            34323290521731,  // Gift Box
            43449192841347,  // Engraving
            43636224491651,  // Gift Message
            44421842534531   // Additional Upsell
        ]

        // Count eligible items (exclude upsells by variant ID, include BOGO)
        let eligibleItemCount = 0
        cart.items.forEach(item => {
            const isUpsell = UPSELL_VARIANT_IDS.includes(item.variant_id)

            if (!isUpsell) {
                eligibleItemCount += item.quantity
            }
        })

        // Calculate cart total in dollars
        const cartTotal = cart.total_price / 100

        // Determine goal status and message
        let message = ''
        let progress = 0
        let goalsCompleted = 0

        // Check shipping threshold first (Goal 1)
        if (cartTotal < shippingThreshold) {
            // Working toward free shipping
            const remaining = shippingThreshold - cartTotal
            message = `<p>You're <strong>$${remaining.toFixed(2)}</strong> away from <strong>FREE SHIPPING!</strong></p>`
            progress = (cartTotal / shippingThreshold) * 33.33
            goalsCompleted = 0
        } else if (eligibleItemCount < goal2Threshold) {
            // Passed shipping, working toward Goal 2 (4 items for Buy 2 Get 2)
            goalsCompleted = 1

            if (eligibleItemCount === 3) {
                message = `<p>Add <strong>1</strong> more item for <strong>Buy 2 Get 2 FREE!</strong></p>`
            } else if (eligibleItemCount === 2) {
                message = `<p>Add <strong>2</strong> more items for <strong>Buy 2 Get 2 FREE!</strong></p>`
            } else if (eligibleItemCount === 1) {
                message = `<p>Add <strong>3</strong> more items for <strong>Buy 2 Get 2 FREE!</strong></p>`
            } else {
                message = `<p>Add items to unlock <strong>Buy 2 Get 2 FREE!</strong></p>`
            }

            progress = 33.33 + (eligibleItemCount / goal2Threshold) * 33.33
        } else if (eligibleItemCount < goal3Threshold) {
            // Passed Goal 2, working toward Goal 3 (6 items for Buy 3 Get 3)
            goalsCompleted = 2

            if (eligibleItemCount === 4) {
                // Special transition message at 4 items
                message = `<p><strong>Add another Item, Get Another FREE!</strong></p>`
            } else if (eligibleItemCount === 5) {
                message = `<p>Add <strong>1</strong> more item for <strong>Buy 3 Get 3 FREE!</strong></p>`
            } else {
                message = `<p>Keep going for <strong>Buy 3 Get 3 FREE!</strong></p>`
            }

            const progressInTier = (eligibleItemCount - goal2Threshold) / (goal3Threshold - goal2Threshold)
            progress = 66.66 + (progressInTier * 33.34)
        } else {
            // All goals completed
            goalsCompleted = 3
            message = `<p><strong>Congrats! You've unlocked ALL rewards!</strong> 🎉</p>`
            progress = 100
        }

        // Update DOM
        const messageContainer = cartGoal.querySelector('.cart-goal-message')
        const progressBar = cartGoal.querySelector('.progress-bar')

        if (messageContainer) {
            messageContainer.innerHTML = message
        }

        if (progressBar) {
            progressBar.style.width = `${progress}%`
            progressBar.setAttribute('aria-valuenow', progress)
            progressBar.dataset.width = `${progress}%`
        }

        // Update icon states
        const icons = cartGoal.querySelectorAll('.cart-goal-icons li')
        icons.forEach((icon, index) => {
            if (index < goalsCompleted) {
                icon.classList.add('active')
            } else {
                icon.classList.remove('active')
            }
        })

        // Handle free product auto-add (if configured)
        await handleFreeProduct(cart, goalsCompleted)

    } catch (error) {
        console.error('Error updating cart goal:', error)
    }
}

// Handle free product auto-add
const handleFreeProduct = async (cart, goalsCompleted) => {
    const cartGoal = document.querySelector('#cart-goal')
    if (!cartGoal) return

    const freeProductHandle = cartGoal.dataset.freeProductHandle
    const freeProductVariantId = cartGoal.dataset.freeProductVariantId

    if (!freeProductHandle || !freeProductVariantId) return

    // Check if we should add free product (all goals completed)
    if (goalsCompleted >= 3) {
        let hasFreeProduct = false

        cart.items.forEach(item => {
            if (item.product_handle === freeProductHandle) {
                hasFreeProduct = true
            }
        })

        if (!hasFreeProduct) {
            // Add free product
            const response = await fetch('/cart/add.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    items: [{
                        id: Number(freeProductVariantId),
                        quantity: 1
                    }]
                })
            })

            if (response.ok) {
                window.refreshCartContents(response)
            }
        }
    }
}

// Initialize on page load
document.addEventListener('DOMContentLoaded', () => {
    updateCartGoal()
})

// Update on cart changes
window.addEventListener('updated.ecomify.cart', () => {
    updateCartGoal()
})

// Summary card on the cart page - sticky on desktop
const initStickySummaryCard = () => {
    const card = document.querySelector('#cart-summary')

    if (!card) return

    if (window.matchMedia('max-width: 991px').matches) return

    const navbarHeight = document.querySelector('[id*="__navbar"].sticky-top')?.clientHeight || 0
    const announcementBarHeight = document.querySelector('[id*="__announcement-bar"].sticky-top')?.clientHeight || 0

    card.style.position = 'sticky'
    card.style.top = `${navbarHeight + announcementBarHeight + 20}px`
}
initStickySummaryCard()

window.addEventListener('updated.ecomify.cart', () => {
    initStickySummaryCard()
})

// Generate Shipping rates
// https://shopify.dev/docs/api/ajax/reference/cart#generate-shipping-rates
window.generateShippingRates = async (btn) => {
    btn.innerHTML = `
        <div class="spinner-border spinner-border-sm" role="status" style="width: 1rem; height: 1rem">
            <span class="visually-hidden">Loading...</span>
        </div>
    `

    const wrapper = document.querySelector('#cart-shipping-rates-collapse')

    wrapper.querySelector('#shipping-rates-modal-alert-danger').innerHTML = ''
    wrapper.querySelector('#shipping-rates-modal-alert-danger').setAttribute('hidden', 'hidden')
    wrapper.querySelector('#shipping-rates-modal-alert-warning').innerHTML = ''
    wrapper.querySelector('#shipping-rates-modal-alert-warning').setAttribute('hidden', 'hidden')
    wrapper.querySelector('#shipping-rates-modal-alert-success').innerHTML = ''
    wrapper.querySelector('#shipping-rates-modal-alert-success').setAttribute('hidden', 'hidden')

    const country = wrapper.querySelector('#shipping-rates-modal-country').value
    const province = wrapper.querySelector('#shipping-rates-modal-province').value
    const zip = wrapper.querySelector('#shipping-rates-modal-zip').value

    const prepareResponse = await fetch(`/cart/prepare_shipping_rates.json?shipping_address[zip]=${zip}&shipping_address[country]=${country}&shipping_address[province]=${province}`, {
        method: 'POST'
    })
    console.log(prepareResponse)

    if (prepareResponse.ok) {
        const asyncRespose = await fetch(`/cart/async_shipping_rates.json?shipping_address[zip]=${zip}&shipping_address[country]=${country}&shipping_address[province]=${province}`)
        console.log(asyncRespose)

        const data = await asyncRespose.json()
        console.log(data)

        let html = ''

        if (data.shipping_rates.length) {
            data.shipping_rates.forEach(elem => {
                html += `
                    <li>
                        <strong>${elem.presentment_name}</strong>: ${elem.price} ${elem.currency}
                    </li>
                `
            })

            wrapper.querySelector('#shipping-rates-modal-alert-success').innerHTML = `
                <ul class="ps-5 mb-0">
                    ${html}
                </ul>
            `
            wrapper.querySelector('#shipping-rates-modal-alert-success').removeAttribute('hidden')
        } else {
            wrapper.querySelector('#shipping-rates-modal-alert-warning').innerHTML = `
                <p class="mb-0">
                    ${wrapper.dataset.textNoResults}
                </p>
            `
            wrapper.querySelector('#shipping-rates-modal-alert-warning').removeAttribute('hidden')
        }
    } else {
        const data = await prepareResponse.json()
        console.log(data)

        let html = ''

        for (const [key, value] of Object.entries(data)) {
            html += `
                <li>
                    <strong>${key}</strong>: ${value.toString()}
                </li>
            `
        }

        wrapper.querySelector('#shipping-rates-modal-alert-danger').innerHTML = `
            <ul class="ps-5 mb-0">
                ${html}
            </ul>
        `
        wrapper.querySelector('#shipping-rates-modal-alert-danger').removeAttribute('hidden')
    }

    btn.innerHTML = btn.dataset.text
}

// Offcanvas cart - fix scrolling for callapses
const fixScrollingOffcanvasCollapses = () => {
    document.querySelectorAll('#offcanvas-cart [data-bs-toggle="collapse"]').forEach(elem => {
        elem.addEventListener('click', () => {
            setTimeout(() => {
                const offcanvasBody = document.querySelector('#offcanvas-cart .offcanvas-body')
                offcanvasBody.scroll({ top: offcanvasBody.scrollHeight, behavior: 'smooth' })
            }, 250)
        })
    })
}
fixScrollingOffcanvasCollapses()

window.addEventListener('updated.ecomify.cart', () => {
    fixScrollingOffcanvasCollapses()
})

// Upgrade to subscription
window.onChangeCartUpgradeToSub = async (select) => {
    await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
            id: select.dataset.lineItemKey,
            quantity: 0
        })
    })

    const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
            items: [{
                quantity: Number(select.dataset.quantity),
                id: Number(select.dataset.variantId),
                selling_plan: Number(select.value)
            }]
        })
    })

    window.refreshCartContents(response)
}

// Gift Wrap
window.onChangeCartGiftWrap = async (input) => {
    let response

    if (input.checked) {
        response = await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                items: [{
                    quantity: 1,
                    id: Number(input.value)
                }]
            })
        })
    } else {
        response = await fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                id: input.dataset.lineItemKey,
                quantity: 0
            })
        })
    }
    window.refreshCartContents(response)
}

// Cart Min Order
const initCartMinOrder = () => {
    const wrapper = document.querySelector('#cart-min-order')
    if (!wrapper) return

    if (wrapper.dataset.goalReached === 'false') {
        wrapper.closest('form').querySelector('.btn-checkout').disabled = true
    }
}
initCartMinOrder()
window.addEventListener('updated.ecomify.cart', () => {
    initCartMinOrder()
})

// Shipping protection
const initCartShippingProtection = async () => {
    if (!document.querySelector('[data-shipping-protection-enabled="true"]')) return
    if (!document.querySelector('[data-shipping-protection-auto-init="true"]')) return

    if (!window.localStorage.getItem('ecomify-shipping-protection-init')) {
        const variantId = Number(document.querySelector('[data-shipping-protection-variant-id]').dataset.shippingProtectionVariantId)

        const response = await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                items: [{
                    quantity: 1,
                    id: variantId
                }]
            })
        })

        window.refreshCartContents(response)
        window.localStorage.setItem('ecomify-shipping-protection-init', true)
    }
}
window.addEventListener('updated.ecomify.cart', () => {
    initCartShippingProtection()
})

window.onChangeCartShippingProtection = async (input) => {
    let response

    if (input.checked) {
        response = await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                items: [{
                    quantity: 1,
                    id: Number(input.value)
                }]
            })
        })
    } else {
        response = await fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                id: input.dataset.lineItemKey,
                quantity: 0
            })
        })
    }
    window.refreshCartContents(response)
}

// Variant switcher
window.onChangeCartLineItemVariant = async (select) => {
    await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
            id: select.dataset.lineItemKey,
            quantity: 0
        })
    })

    const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
            items: [{
                quantity: Number(select.dataset.quantity),
                id: Number(select.value),
                selling_plan: select.dataset.sellingPlanId.length
                    ? Number(select.dataset.sellingPlanId)
                    : null
            }]
        })
    })

    window.refreshCartContents(response)
}

// Terms checkbox
const initTermsCheckbox = () => {
    const checkbox = document.querySelector('#cart-terms-checkbox')

    if (!checkbox) return

    const checkoutBtn = checkbox.closest('form').querySelector('.btn-checkout')
    checkoutBtn.disabled = true

    checkbox.addEventListener('change', () => {
        if (checkbox.checked) {
            checkoutBtn.disabled = false
        } else {
            checkoutBtn.disabled = true
        }
    })
}
initTermsCheckbox()

window.addEventListener('updated.ecomify.cart', () => {
    initTermsCheckbox()
})

// Cart Discount
window.onCartDiscountClick = async (btn) => {
    const wrapper = document.querySelector('#cart-discount')

    btn.innerHTML = `
        <div class="spinner-border spinner-border-sm" role="status" style="width: 1rem; height: 1rem">
            <span class="visually-hidden">Loading...</span>
        </div>
    `
    await fetch(`/discount/${wrapper.querySelector('.form-control').value}`)
    window.location.href = '/checkout'
}
